import { Route } from 'react-router-dom';

import i18n from 'i18next';

import { subAppPage } from '@talend/sub-app-system';

import cmfModule from './cmfModule';
import { CADAdd, CADEdit, CADEditProps, CADList } from './components';

const CADListPage = subAppPage({})(CADList);
const CADAddPage = subAppPage({ isFullPage: true })(CADAdd);
// @ts-ignore
const CADEditPage = subAppPage<Partial<CADEditProps>>({ isFullPage: true })(CADEdit);

const routes = [
	<Route key="cad-list" path="/custom-attributes" element={<CADListPage />} />,
	<Route key="cad-form-add" path="/custom-attributes/add" element={<CADAddPage />} />,
	<Route key="cad-form-edit" path="/custom-attributes/:id/edit" element={<CADEditPage />} />,
];

// This is declared as a function in order to evaluate the i18n
// value at render (when we have resolve the user language)
function getSidePanelMenus(): any {
	return {
		cad: {
			label: i18n.t('tdc-app:CUSTOM_ATTRIBUTES', {
				defaultValue: 'Custom attributes',
			}),
			'data-feature': 'custom_attribute.list',
			iconName: 'tag',
			entitlements: ['CUSTOM_ATTRIBUTE_READ'],
			href: '/custom-attributes',
		},
	};
}

export const cadSubApplication = {
	routes,
	getSidePanelMenus,
	cmfModule,
};
